import {
  Card,
  CardContent,
  CardHeader,
  CardSelectButton,
  Typography,
} from '@customink/pigment-react';

export function VerificationMethodCard({
  onClick,
  selected,
  title,
  description,
  subtitle,
  verificationMethod,
}: {
  onClick: (
    e: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>,
    method: string,
  ) => void;
  verificationMethod: string;
  selected: boolean;
  title: string;
  description: string;
  subtitle: string;
}) {
  return (
    <Card
      onClick={(event) => onClick(event, verificationMethod)}
      selected={selected}
      sx={{ cursor: 'pointer' }}
    >
      <CardSelectButton
        onClick={(event) => onClick(event, verificationMethod)}
        selected={selected}
      />
      <CardHeader title={title} />
      <CardContent>
        <Typography variant="paragraphDefault" weight="bold">
          {subtitle}
        </Typography>
        <Typography>{description}</Typography>
      </CardContent>
    </Card>
  );
}
